import { useState } from "react";
import { Navbar as BootstrapNavbar, Button, Dropdown } from "react-bootstrap";
import DaneaLogo from "assets/daneaimport-logo-title-w.png";
import { FormatFileModal } from "./format-file-modal";
import { StrumentiDropdown } from "./strumenti-dropdown";
import { QrModal } from "./qr-modal";

export const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFormatFileModal, setShowFormatFileModal] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCloseFormatFileModal = () => {
    setShowFormatFileModal(false);
    setShowDropdown(false);
  };

  const handleCloseQrModal = () => {
    setShowQrModal(false);
    setShowDropdown(false);
  };
 
  const handleFileModalActions = () =>{
    setShowFormatFileModal(true);
    setShowDropdown(false)
  }

  const handleQrModalActions = () =>{
    setShowQrModal(true);
    setShowDropdown(false);
  }
  return (
    <>
      <BootstrapNavbar
        bg="primary"
        expand="lg"
        className="px-2 justify-content-between w-100"
      >
        <BootstrapNavbar.Brand href="#">
          <img
            src={DaneaLogo}
            alt="Logo"
            className="mx-2"
            style={{ width: 200 }}
          />
        </BootstrapNavbar.Brand>

        <div className="d-none d-lg-block">
          <Dropdown show={showDropdown}>
            <Button
              className="text-primary"
              style={{ backgroundColor: "white" }}
              onClick={toggleDropdown}
            >
              <i className="bi bi-tools px-2"></i>
              STRUMENTI
            </Button>
            <StrumentiDropdown
              handleFileSupportati={handleFileModalActions}
              handleQrCode={handleQrModalActions}
            />
          </Dropdown>
        </div>

        <div className="d-lg-none">
          <Dropdown show={showDropdown}>
            <i
              className="bi bi-three-dots-vertical text-white"
              onClick={toggleDropdown}
            ></i>
            <StrumentiDropdown
              handleFileSupportati={() => setShowFormatFileModal(true)}
              handleQrCode={() => setShowQrModal(true)}
            />
          </Dropdown>
        </div>
      </BootstrapNavbar>
      <FormatFileModal
        show={showFormatFileModal}
        closeModal={handleCloseFormatFileModal}
      />
      <QrModal show={showQrModal} closeModal={handleCloseQrModal} />
    </>
  );
};
